import request from '@/plugins/request/system';

/**
 * 获取基础数据
 * @constructor
 */
export function AccountInit(){
  return request({
    url: '/systemv1/admin/init',
    method: 'get'
  });
}


/**
 * 获取管理信息 | 并修改
 * @param String adminId
 * @constructor
 */
export function AccountInfo(adminId) {
  return request({
    url: '/systemv1/admin/info',
    method: 'post',
    data : {id:adminId}
  });
}

/**
 * 修改数据
 * @param data
 * @constructor
 */
export function AccountUpdate(data) {
  return request({
    url: '/systemv1/admin/edit',
    method: 'post',
    data : data
  });
}

/**
 * 修改密码
 * @param data
 * @constructor
 */
export function AccountPass(data) {
  return request({
    url: '/systemv1/admin/password',
    method: 'post',
    data : data
  });
}



// WEBPACK FOOTER //
// ./src/api/system/account.js